import withErrorFallback from "@components/ErrorBoundary/withErrorFallback";

import Footer from "./Footer";
import FooterFallback from "./FooterFallback";

export default withErrorFallback(Footer, FooterFallback);
